/**
 * responseInterceptor : response interceptor
 *
 * @author Nitesh <nitesh.meena@biz2credit.com>
 *
 * @param response object
 */
const responseInterceptor = (response) => {
    if (response instanceof Array) return response;
    if (typeof response === 'string') response = JSON.parse(response);
    if (response && response.data) return response.data;
    return response;
};

/**
 * responseV2Interceptor : response interceptor
 *
 * @author Nitesh <nitesh.meena@biz2credit.com>
 *
 * @param response object
 * @param slug
 * @param further_process
 */
const responseV2Interceptor = (response, slug, further_process = true) => {
    let obj = initScript.getObjectValue(response, "data.response_data." + slug + ".data");
    if (!obj) obj = response;
    if (further_process) return responseInterceptor(obj || response);
    while(initScript.getObjectValue(obj, "data")) obj = initScript.getObjectValue(obj, "data");
    return obj || response;
};


/**
 * getV2URL : url generating interceptor
 *
 * @author Nitesh <nitesh.meena@biz2credit.com>
 *
 * @param url
 * @param end_point
 * @param slug_config
 */
const getV2URL = (url, end_point, slug_config, ignoreSlug = false) => {
    const other = "internal=true", len = url.length;
    if (!len) return null;
    if (url[len - 1] !== "/") url = url + "/";
    if (!slug_config || !slug_config[end_point]) {
        return url + end_point + "?" + other;
        // if (!!slug_config[end_point]) return url + end_point + "?" + other;
        // else return url + end_point;
    }
    else if(ignoreSlug && slug_config[end_point] === ignoreSlug.values[end_point]){
        var serviceURL = (ignoreSlug.service_api[ignoreSlug.service_api.length - 1] !== "/") ? ignoreSlug.service_api + "/" : ignoreSlug.service_api;
        return serviceURL + end_point + "?" + other;
    }
    return url + "tasks?slug=" + slug_config[end_point] + "&" + other;
};